import { render, staticRenderFns } from "./element-Properties.vue?vue&type=template&id=7e0c3d4b"
import script from "./element-Properties.vue?vue&type=script&lang=js"
export * from "./element-Properties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports